import { LoginFormPage } from './loginForm/LoginFormPage';
const LoginPage = () => {
  return (
    <>
        <LoginFormPage></LoginFormPage>
    </>
  )
}

export default LoginPage
